import { useLocalStorage, useMedia } from "react-use";
import { createContainer } from "unstated-next";

// Below this width the 260px section nav leaves too little room for page
// content, so the nav is forced into its icon-only state. The user's stored
// preference is left untouched and takes over again on wider viewports.
const NARROW_QUERY = "(max-width: 1200px)";

function usePageNavState() {
  const [collapsed, setCollapsed] = useLocalStorage("page-nav-collapse", false);
  const isNarrow = useMedia(NARROW_QUERY, false);

  return { collapsed: isNarrow || collapsed, setCollapsed };
}

export const PageNavState = createContainer(usePageNavState);
